/**
 * Frontend route paths for the client (company) section.
 * Backend API remains under /companies; only browser URLs use /clients.
 */

/** List of clients (replaces /companies) */
export const CLIENT_LIST_PATH = '/clients';

/** Create new client (replaces /companies/new) */
export const CLIENT_NEW_PATH = '/clients/new';

/** Client detail/edit page (replaces /companies/:id/edit) */
export function clientDetailPath(id: string): string {
  return `/clients/${id}`;
}

/** Administration usage: clients list view (replaces /administration/usages/companies) */
export const ADMIN_USAGES_CLIENTS_PATH = '/administration/usages/clients';

/** Administration usage: single client usage (replaces /administration/usages/companies/:companyId) */
export function adminUsagesClientPath(companyId: string): string {
  return `${ADMIN_USAGES_CLIENTS_PATH}/${companyId}`;
}

/** Administration usage: invite history for a client (replaces /administration/usages/companies/:companyId/invites/:userId) */
export function adminUsagesClientInvitesPath(companyId: string, userId: string): string {
  return `${ADMIN_USAGES_CLIENTS_PATH}/${companyId}/invites/${userId}`;
}
